/**
 * SchedulePublicationModal
 * Modal pour planifier la publication d'un article sur WordPress
 */
import React from 'react';
import { CalendarClock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

export const SchedulePublicationModal = ({
  scheduleModal,
  publishingItem,
  onClose,
  onDateChange,
  onConfirm,
}) => {
  if (!scheduleModal) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" 
      onClick={onClose} 
      data-testid="schedule-modal"
    >
      <Card className="border-blue-500/50 bg-slate-900 max-w-md w-full" onClick={e => e.stopPropagation()}>
        <CardHeader>
          <CardTitle className="text-sm text-blue-300 flex items-center gap-2">
            <CalendarClock className="w-4 h-4" /> Planifier la publication
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="text-xs text-slate-400">
            Article : <span className="text-slate-200">{scheduleModal.item?.title}</span>
          </div>
          <div>
            <label className="text-[10px] text-slate-500 uppercase">Date et heure (heure locale)</label>
            <Input
              type="datetime-local"
              value={scheduleModal.date}
              onChange={e => onDateChange(e.target.value)}
              className="w-full"
              data-testid="schedule-datetime-input"
            />
            <div className="text-[10px] text-slate-500 mt-1">
              WordPress publiera automatiquement à cette date (statut « future »).
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button onClick={onClose} variant="outline" size="sm" data-testid="schedule-cancel-btn">
              Annuler
            </Button>
            <Button
              onClick={onConfirm}
              disabled={publishingItem === scheduleModal.item?.id}
              className="bg-blue-600 hover:bg-blue-500"
              size="sm"
              data-testid="schedule-confirm-btn"
            >
              <CalendarClock className="w-3 h-3 mr-1" /> 
              {publishingItem === scheduleModal.item?.id ? 'Planification…' : 'Confirmer'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SchedulePublicationModal;
